import { registerPlugin } from '@capacitor/core';
const CapacitorFile = registerPlugin('CapacitorFile', {
    web: () => import('./web').then((m) => new m.CapacitorFileWeb()),
});
export * from './definitions';
export { CapacitorFile };
//# sourceMappingURL=index.js.map